import CIMSTable from 'components/CIMSTable'
import { CSVEntity } from 'shared'
import {
  ConcreteMixDesignsProvider,
  useConcreteMixDesignsContext,
} from './MixDesignsContext'
import { useColumns } from './hooks/useColumns'
import { useExpand } from './hooks/useExpand'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useCustom } from './hooks/useCustom'
import CreateModal from './components/CreateModal'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import { CustomFieldClassType } from 'shared'

const InnerTable: React.VFC = () => {
  const { concreteMixDesigns, loading, refetch } =
    useConcreteMixDesignsContext()

  return (
    <CIMSTable
      rowKey="globalId"
      loading={loading}
      records={concreteMixDesigns}
      columns={useColumns()}
      actions={{
        header: {
          deepLinkKey: 'globalId',
          create: useCreate(),
          onReload: refetch,
          csv: CSVEntity.ConcreteMixDesign,
        },
        row: {
          edit: useEdit(),
          custom: useCustom(),
        },
      }}
      expand={useExpand()}
    >
      <CreateModal />
    </CIMSTable>
  )
}

const ConcreteMixDesigns: React.VFC = () => {
  return (
    <ProjectCustomFieldsProvider
      classType={CustomFieldClassType.ConcreteMixDesign}
    >
      <ConcreteMixDesignsProvider>
        <InnerTable />
      </ConcreteMixDesignsProvider>
    </ProjectCustomFieldsProvider>
  )
}

export default ConcreteMixDesigns
